import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container split-section">
          <div>
            <p className="eyebrow">About ProgrammoCeuticals</p>
            <h1>Bridging pharmacy expertise with modern technology.</h1>
            <p className="section-intro left">
              We build tools and training that help students, faculty, industry, and regulatory
              teams deliver better outcomes with clarity, security, and measurable impact.
            </p>
            <div className="about-highlights">
              <div>
                <h3>Pharmacy-led</h3>
                <p>Designed by practitioners who understand compliance and education workflows.</p>
              </div>
              <div>
                <h3>Technology-first</h3>
                <p>Modern platforms that streamline documentation, learning, and reporting.</p>
              </div>
            </div>
            <Link to="/contact" className="btn btn-primary">Talk to Us</Link>
          </div>
          <div className="section-visual">
            <img src="/images/hero-team-lagos.jpg" alt="ProgrammoCeuticals team collaborating" />
          </div>
        </div>
      </section>

      <section className="about-mission section-surface">
        <div className="container">
          <h2>Our Mission</h2>
          <p className="section-intro">
            To empower pharmaceutical education, regulatory compliance, and industry workflows
            through reliable, easy-to-use technology.
          </p>
          <div className="cards-grid">
            <div className="card">
              <h3>Education Impact</h3>
              <p>Give students and faculty structured learning paths and dependable academic systems.</p>
            </div>
            <div className="card">
              <h3>Regulatory Confidence</h3>
              <p>Enable teams to prepare submissions and audits with organized, traceable workflows.</p>
            </div>
            <div className="card">
              <h3>Industry Efficiency</h3>
              <p>Automate documentation and approvals to reduce friction and accelerate delivery.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-values">
        <div className="container">
          <h2>Our Values</h2>
          <div className="values-grid">
            <div className="value">
              <h3>Clarity</h3>
              <p>Clear, intuitive interfaces that reduce complexity.</p>
            </div>
            <div className="value">
              <h3>Compliance</h3>
              <p>Regulatory-ready workflows with audit trails and accountability.</p>
            </div>
            <div className="value">
              <h3>Quality</h3>
              <p>Rigorous testing and reliability expected in healthcare systems.</p>
            </div>
            <div className="value">
              <h3>Scalability</h3>
              <p>Solutions that grow from individual use to enterprise deployment.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-story section-surface">
        <div className="container">
          <h2>Why We Exist</h2>
          <p className="section-intro">
            Pharmaceutical workflows are complex and often underserved by generic software.
            ProgrammoCeuticals was built to close that gap with tools created for local realities.
          </p>
          <div className="story-grid">
            <div className="story-card">
              <h3>Real-world context</h3>
              <p>We design around the actual regulatory and academic processes teams use daily.</p>
            </div>
            <div className="story-card">
              <h3>Secure by design</h3>
              <p>Privacy-first architecture ensures sensitive data is handled responsibly.</p>
            </div>
            <div className="story-card">
              <h3>Long-term partnership</h3>
              <p>We focus on sustainable support and continuous improvements over time.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="container">
          <h2>Get in Touch</h2>
          <p className="section-intro">
            Ready to explore the right solution for your team? We will guide you to the best fit.
          </p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-primary">Contact Us</Link>
            <Link to="/products" className="btn btn-secondary">View Products</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
